import React from "react";
import SignUpFrom from "./SignUpfrom";

const Sign = () => {
  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="login-box">
          <SignUpFrom />
        </div>
      </div>
    </div>
  );
};

export default Sign;
